import { render, staticRenderFns } from "./TolSidebar.vue?vue&type=template&id=52c67cfe&scoped=true&"
import script from "./TolSidebar.vue?vue&type=script&lang=js&"
export * from "./TolSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TolSidebar.vue?vue&type=style&index=0&id=52c67cfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c67cfe",
  null
  
)

export default component.exports